import type { Hcp } from '@/core/graphql/generated/types';

export const mapAddressesIn = (src: Hcp['addresses']) => {
	if (!src?.length) return [];

	return src
		.filter(a => a.statusCda_VId !== 'iact')
		.map(addr => ({
			vid_V: addr.vid_V,
			_origEmptyStreet: !addr.streetAddress1Cda_V,
			_origEmptyCity: !addr.cityCda_V,
			streetAddress1Cda_V: addr.streetAddress1Cda_V ?? '',
			streetAddress2Cda_V: addr.streetAddress2Cda_V ?? '',
			cityCda_V: addr.cityCda_V ?? '',
			stateCda_V: addr.stateCda_V ?? '',
			countryCda_V:
				addr.countryCda_V === 'Great Britain'
					? 'United Kingdom'
					: (addr.countryCda_V ?? ''),

			postalCodeCda_V: addr.postalCodeCda_V ?? '',
			postalCodeFullUs_V: addr.postalCodeFullUs_V ?? '',

			subStateAdminUnit_V: addr.subStateAdminUnit_V ?? '',
			cbsa_V: addr.cbsa_V ?? '',

			phoneCda_V: addr.phoneCda_V ?? '',
			faxCda_V: addr.faxCda_V ?? '',

			primaryCda_V: addr.primaryCda_V ?? false,
			businessCda_V: addr.businessCda_V ?? false,
			statusCda_V: addr.statusCda_V ?? '',

			// Hidden / System fields
			buildingIdentifier_V: addr.buildingIdentifier_V ?? '',
			dpvConfirmedIndicator_V: addr.dpvConfirmedIndicator_V ?? '',
			latitudeCda_V: addr.latitudeCda_V ?? null,
			longitudeCda_V: addr.longitudeCda_V ?? null
		}));
};
